/**
 * Created by Carsten Bühler
 * User: c.buehler on 22.03.2019
 * Copyright: xdot GmbH 2019
 */

export default function getGroupSchemaProperties(groupSchema){
    if (groupSchema && groupSchema.allOf && groupSchema.allOf.length>=2){
        return groupSchema.allOf[1].properties;
    }
    return undefined;
}



// WEBPACK FOOTER //
// ./js/utils/group-schema-util.js